<template>
  <div class="page-main" style="padding-bottom:40px">
      <div class="contract-box" v-html="artcCntnt">
      </div>
      <div class="spaceCenter">
        <a-button class="btn-blue-line" style="margin:30px 0;" @click="goBack()">返回</a-button>
    </div>
  </div>
</template>

<script>
import {borrowedContractList} from "@/api/goldseller.js"
export default {
    name:"contractDetail",
    data() {
        return {
            artcCntnt:""
        };
    },
    computed: {},
    methods: {
        borrowedContractList(){
            const row = this.$route.params;
            let params;
            params = {
                ...row,
                applyDate: row.fncBgDt || ''
            };
            params.goldList = JSON.stringify(params.goldList);
            borrowedContractList(params,true)
            .then(res => {
                this.artcCntnt = res.data.artcCntnt;
            })
            .catch(err => {
                console.log(err);
            })
        },
        goBack(){
            this.$router.go(-1);
        }
    },
    created() {
        this.borrowedContractList();
    },
    mounted() {},
    activated() {},
    watch: {},
};
</script>
<style scoped>
.contract-box{
    width: 86%;
    margin:0 auto;
    border: #e9ebee 1px solid;
    margin-top: 30px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/financing-page/contract-detail.vue